// src/components/OrganizerMismatch.js
//
// Full-screen interstitial shown when a logged-in organizer visits a
// DIFFERENT organizer's subdomain (e.g. logged in as darrins-pool but
// browsing dh-test.heberthoops.com). Blocks the app shell entirely --
// nothing underneath mounts while this is showing, so there's no risk
// of a flash of mismatched branding + own data.
//
// Deliberately says nothing about the OTHER organizer or what does/does
// not exist behind this URL -- the message is scoped to the viewer's
// own identity ("you're logged in as X") and never implies anything
// about what staying logged in here would or wouldn't show them.
//
// Platform admins never see this (see App.js) -- their cross-organizer
// access is handled explicitly via Impersonate, which is logged and
// opt-in, not an implicit side effect of which subdomain they're on.

import React from 'react';
import { logout as apiLogout } from '../services/api';
import { buildSubdomainUrl } from '../lib/subdomain';

function OrganizerMismatch({ user, ownSlug, onLogout }) {
    const goToOwnPool = () => {
        window.location.href = buildSubdomainUrl(ownSlug, window.location);
    };

    const handleLogout = async () => {
        try {
            await apiLogout();
        } catch {
            // Same best-effort handling as App.js's handleLogout --
            // clear local state regardless of whether the network call
            // succeeded.
        }
        onLogout();
    };

    return (
        <div className="min-h-screen bg-gray-950 text-white flex items-center justify-center px-4">
            <div className="max-w-md w-full bg-gray-900 border border-gray-800 rounded-2xl p-8 text-center">
                <h1 className="text-xl font-bold mb-3">Wrong pool for this account</h1>
                <p className="text-gray-400 mb-6">
                    You're logged in as <span className="text-white font-semibold">{user.name}</span>.
                    This page belongs to a different organizer's pool.
                </p>
                <div className="flex flex-col gap-3">
                    <button
                        onClick={goToOwnPool}
                        className="bg-orange-500 hover:bg-orange-600 text-gray-950 font-bold py-2 rounded-lg transition-colors">
                        Go to my pool
                    </button>
                    <button
                        onClick={handleLogout}
                        className="bg-gray-800 hover:bg-gray-700 text-gray-300 font-bold py-2 rounded-lg transition-colors">
                        Log out
                    </button>
                </div>
            </div>
        </div>
    );
}

export default OrganizerMismatch;